export default __webpack_public_path__ + "static/media/Tutorial-Step-1.2.4fea8916.jpg";